"use strict";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// Tooltip Init
// Unuse by Hux since V1.6: Titles now display by default so there is no need for tooltip
// $(function() {
//     $("[data-toggle='tooltip']").tooltip();
// });

// make all images responsive
/* 
 * actually only Portfolio-Pages can't use it and only post-img need it.
 * so I modify the _layout/post and CSS to make post-img responsive!
 */
// $(function() {
//  $("img").addClass("img-responsive");
// });

// responsive tables
$(document).ready(function () {
  $("table").wrap("<div class='table-responsive'></div>");
  $("table").addClass("table");
});

// responsive embed videos
$(document).ready(function () {
  $('iframe[src*="youtube.com"]').wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
  $('iframe[src*="youtube.com"]').addClass('embed-responsive-item');
  $('iframe[src*="vimeo.com"]').wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
  $('iframe[src*="vimeo.com"]').addClass('embed-responsive-item');
});

// Navigation Scripts to Show Header on Scroll-Up
jQuery(document).ready(function ($) {
  var MQL = 1170;

  //primary navigation slide-in effect
  if ($(window).width() > MQL) {
    var headerHeight = $('.navbar-custom').height(),
      bannerHeight = $('.intro-header .container').height();
    $(window).on('scroll', {
      previousTop: 0
    }, function () {
      var currentTop = $(window).scrollTop(),
        $catalog = $('.side-catalog');

      //check if user is scrolling up by mouse or keyborad
      if (currentTop < this.previousTop) {
        //if scrolling up...
        if (currentTop > 0 && $('.navbar-custom').hasClass('is-fixed')) {
          $('.navbar-custom').addClass('is-visible');
        } else {
          $('.navbar-custom').removeClass('is-visible is-fixed');
        }
      } else {
        //if scrolling down...
        $('.navbar-custom').removeClass('is-visible');
        if (currentTop > headerHeight && !$('.navbar-custom').hasClass('is-fixed')) $('.navbar-custom').addClass('is-fixed');
      }
      this.previousTop = currentTop;

      //adjust the appearance of side-catalog
      $catalog.show();
      if (currentTop > bannerHeight + 41) {
        $catalog.addClass('fixed');
      } else {
        $catalog.removeClass('fixed');
      }
    });
  }
});
(function ($) {
  if (!!window.mermaid) {
    var needMermaid = false;
    $('.language-mermaid').parent().replaceWith(function () {
      needMermaid = true;
      return $('<pre class="mermaid">').text($(this).text());
    });
    if (!needMermaid) {
      mermaid.initialize({
        startOnLoad: false
      });
      return;
    }

    // site params are stored with lowercase keys; lookup correct casing
    // from Mermaid default config.
    var norm = function norm(defaultConfig, params) {
      var result = {};
      for (var key in defaultConfig) {
        var keyLower = key.toLowerCase();
        if (defaultConfig.hasOwnProperty(key) && params.hasOwnProperty(keyLower)) {
          if (_typeof(defaultConfig[key]) === "object") {
            result[key] = norm(defaultConfig[key], params[keyLower]);
          } else {
            result[key] = params[keyLower];
          }
        }
      }
      return result;
    };
    var settings = norm(mermaid.mermaidAPI.defaultConfig, {
      enable: !0,
      theme: "default"
    });
    settings.startOnLoad = true;
    mermaid.initialize(settings);
  }
})(jQuery);
function async(u, c) {
  var d = document,
    t = 'script',
    o = d.createElement(t),
    s = d.getElementsByTagName(t)[0];
  o.src = u;
  if (c) {
    o.addEventListener('load', function (e) {
      c(null, e);
    }, false);
  }
  s.parentNode.insertBefore(o, s);
}
$(function () {
  var VAPID_PUBLIC_KEY = 'BGQ0UrY6GwKls0h7EcwpZDCeA-qSczdVxEXmAJJmRDoqLbYhsb4mECPN3hf0xo482SUvfIsemUmWmT531ZCDje4';
  var STORAGE_KEY = 'notification_subscribed';
  var subscribeButton = $('#subscribe-btn');
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    navigator.serviceWorker.register('/service-worker.js').then(function (serviceWorkerRegistration) {
      console.info('Service worker was registered.');
      updateUI();
    })["catch"](function (error) {
      console.error('An error occurred while registering the service worker.');
      console.error(error);
    });
  } else {
    console.error('Browser does not support service workers or push messages.');
  }
  subscribeButton.click( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var result, registration, subscribed, is_save, subscription;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          console.log("subscribe");
          _context.next = 3;
          return Notification.requestPermission();
        case 3:
          result = _context.sent;
          if (!(result === 'denied')) {
            _context.next = 7;
            break;
          }
          console.error('The user explicitly denied the permission request.');
          return _context.abrupt("return");
        case 7:
          if (result === 'granted') {
            console.info('The user accepted the permission request.');
          }
          _context.next = 10;
          return navigator.serviceWorker.getRegistration();
        case 10:
          registration = _context.sent;
          _context.next = 13;
          return registration.pushManager.getSubscription();
        case 13:
          subscribed = _context.sent;
          if (!subscribed) {
            _context.next = 22;
            break;
          }
          console.info('User is already subscribed.');
          is_save = localStorage.getItem(STORAGE_KEY) == 'true';
          if (is_save) {
            _context.next = 21;
            break;
          }
          _context.next = 20;
          return subscribe(subscribed);
        case 20:
          updateUI();
        case 21:
          return _context.abrupt("return");
        case 22:
          _context.next = 24;
          return registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlB64ToUint8Array(VAPID_PUBLIC_KEY)
          });
        case 24:
          subscription = _context.sent;
          _context.next = 27;
          return subscribe(subscription);
        case 27:
          updateUI();
        case 28:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  function updateUI() {
    return _updateUI.apply(this, arguments);
  }
  function _updateUI() {
    _updateUI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var registration, subscribed, is_subscribed;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return navigator.serviceWorker.getRegistration();
          case 2:
            registration = _context2.sent;
            _context2.next = 5;
            return registration.pushManager.getSubscription();
          case 5:
            subscribed = _context2.sent;
            if (subscribed) {
              is_subscribed = localStorage.getItem(STORAGE_KEY) == "true";
              if (is_subscribed) {
                subscribeButton.css('visibility', 'hidden');
              }
            }
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _updateUI.apply(this, arguments);
  }
  var doing = false;
  function subscribe(_x) {
    return _subscribe.apply(this, arguments);
  }
  function _subscribe() {
    _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(subscription) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!doing) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            doing = true;
            _context4.next = 5;
            return fetch('/api/notification/webpush/subscribe', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(subscription)
            }).then(function (res) {
              setTimeout(function () {
                doing = false;
              }, 3000);
              if (res.ok) {
                localStorage.setItem(STORAGE_KEY, true);
                new Notification('订阅成功！');
              }
            })["catch"]( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(err) {
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      doing = false;
                      console.log(err);
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _subscribe.apply(this, arguments);
  }
  function unsubscribe() {
    return _unsubscribe.apply(this, arguments);
  } // Convert a base64 string to Uint8Array.
  // Must do this so the server can understand the VAPID_PUBLIC_KEY.
  function _unsubscribe() {
    _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var registration, subscription, unsubscribed;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return navigator.serviceWorker.getRegistration();
          case 2:
            registration = _context5.sent;
            _context5.next = 5;
            return registration.pushManager.getSubscription();
          case 5:
            subscription = _context5.sent;
            _context5.next = 8;
            return subscription.unsubscribe();
          case 8:
            unsubscribed = _context5.sent;
            if (unsubscribed) {
              console.log("please resubscribe.");
            }
          case 10:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _unsubscribe.apply(this, arguments);
  }
  function urlB64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
});
/* 鼠标特效 */
// jQuery(document).ready(function($) { 
//     var a_idx = 0; 
//     $("body").click(function(e) { 
//         var a = new Array("富强", "民主", "文明", "和谐", "自由", "平等", "公正" ,"法治", "爱国", "敬业", "诚信", "友善"); 
//         var $i = $("<span/>").text(a[a_idx]); 
//         a_idx = (a_idx + 1) % a.length; 
//         var x = e.pageX, 
//         y = e.pageY; 
//         $i.css({ 
//             "z-index": 999999999999999999999999999999999999999999999999999999999999999999999, 
//             "top": y - 20, 
//             "left": x, 
//             "position": "absolute", 
//             "font-weight": "bold", 
//             "color": "#ff6651" 
//         }); 
//         $("body").append($i); 
//         $i.animate({ 
//             "top": y - 180, 
//             "opacity": 0 
//         }, 
//         1500, 
//         function() { 
//             $i.remove(); 
//         }); 
//     }); 
// });
